import React from 'react';

const BadgeBanner = () => {
  return (
    <div className="badges-banner flex relative rounded-xl bg-[url('/public/img/badges/background.svg')] bg-no-repeat bg-cover max-md:bg-center text-white z-20 max-md:h-fit-content max-md:py-6 max-md:px-[17px] min-md:h-[88px] md:mt-[19px] max-md:mt-0 max-lg:mt-4 px-3 mb-6">
      <div
        className="
          badges-banner-illustration
          relative
          bg-[-10px]
          bottom-0
          bg-cover
          bg-no-repeat
          bg-[url('/public/img/badges/astronaut.svg')]
          w-[120px]
          h-[96px]
          mt-[-8px]
          max-md:hidden
        "
      ></div>
      <div className="badges-banner-information flex flex-1 items-center justify-center text-center text-lg text-white font-black">
        Celebrate your achievements by
        <br className="max-lg:hidden" /> collecting badges!
      </div>
      <div
        className="
          badges-banner-illustration-2
          bg-contain
          bg-no-repeat
          bg-[url('/public/img/badges/more_badges.svg')]
          bg-center
          w-[127px]
          h-[70px]
          max-xl:hidden
          mr-4
          my-auto
        "
      ></div>
    </div>
  );
};

export default BadgeBanner;
